function getReplacement (search, replacement) {
    return {
        search,
        replace: `<strong class="v_brand">${replacement}</strong>`
    }
}

const names = [].map(name => getReplacement(name, name))

const customNames = []

customNames.forEach(customName => names.push(getReplacement(customName.join(' '), customName[0] + ` <em>${customName[1]}</em>`)))

export default names
